class CommentForm {
  constructor(container) {
    this.element = container;
    // There are multiple buttons, one is visible for replies and one is visible for
    // top level comments.
    this.buttons = container.querySelectorAll('input[type=submit]');
    this.editor = container.querySelector('.comment-editor');
    this.topLevelCommentableData = document.querySelector('[data-top-level-commentable-type]');
    this.topLevelCommentableType = this.topLevelCommentableData.getAttribute(
      'data-top-level-commentable-type'
    );
    this.topLevelCommentableId = this.topLevelCommentableData.getAttribute(
      'data-top-level-commentable-id'
    );

    const tribute = new Tribute({
      selectClass: 'highlighted',
      values: (text, cb) => {
        this.remoteSearch(text, (users) => cb(users));
      },
      menuShowMinLength: 0,
      noMatchTemplate: '<span style:"visibility: hidden;"></span>',
      lookup: 'username',
      fillAttr: 'username',
      menuItemTemplate: (entry) => {
        // Create regex of name pattern allowing non-letters between letters of pattern, so "ekshm" matches "Joe K. Schmoe"
        const nameRegex = new RegExp(this.editor.value.substring(1).split('').join('\\W*'), 'i'); // abc -> /a\W*b\W*c/i
        // Wrap <span> around the matching part of the name
        const nameWithHighlight = entry.original.name.replace(
          nameRegex,
          '<span class="autocomplete-highlighted">$&</span>'
        );
        const entryTitle = [entry.original.title_at_company, entry.original.company_name]
          .filter((c) => !!c)
          .join(' - ');
        if (entry.original.picture_url) {
          return (
            `<div class="tribute-img-container"><img src="${entry.original.picture_url}" alt="${entry.original.name}"></div>` +
            `<div class="tribute-text-container"><div>${nameWithHighlight}</div><div class="tribute-title">${entryTitle}</div></div>`
          );
        } else {
          return (
            `<div class="tribute-img-container"><div class="placeholder">${entry.original.name[0].toUpperCase()}</div></div>` +
            `<div class="tribute-text-container"><div>${nameWithHighlight}</div><div class="tribute-title">${entryTitle}</div></div>`
          );
        }
      },
    });
    tribute.attach(this.editor);

    autosize(this.editor);

    this.editor.addEventListener('input', this.onEditorInput.bind(this));
    this.onEditorInput();
  }

  onEditorInput() {
    if (this.editor.value.length) {
      this.buttons.forEach((button) => {
        button.classList.remove('disabled');
      });
    } else {
      this.buttons.forEach((button) => {
        button.classList.add('disabled');
      });
    }
  }

  remoteSearch(text, cb) {
    let URL = `/api/v1/mentionable_users?name_fragment=${text}&`;
    if (this.topLevelCommentableType === 'Article') {
      URL += `article_id=${this.topLevelCommentableId}`;
    } else {
      URL += `briefing_id=${this.topLevelCommentableId}`;
    }
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const data = JSON.parse(xhr.responseText).users;
          cb(data);
        } else if (xhr.status === 403) {
          cb([]);
        }
      }
    };
    xhr.open('GET', URL, true);
    xhr.send();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-comment-form]').forEach((el) => new CommentForm(el));
});
